module.exports = __webpack_public_path__ + "static/media/error-icon.07ddd37e.png";